export default __webpack_public_path__ + "static/media/apple26Logo.99eb9023.png";